import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UbicacionService {
  private urlApiFirma = ""

  constructor() { 
    this.urlApiFirma = environment.urlApiFirma;
  }

  public getApiFirmaUrl(): string {
    return this.urlApiFirma + "api/";
}
}
